export default [
  '$window',
  class CareersController {
    constructor($window) {
      let test = $window.whr_embed(7366, {
        detail: 'titles',
        base: 'jobs',
        zoom: 'state',
        grouping: 'none'
      });
    }
  }
]



// WEBPACK FOOTER //
// ./source/client/pages/careers/careers.ctrl.js